/**
 * Yarn Cards Slider - Continuous 1-by-1 Card Carousel
 * Slides 1 card at a time with seamless thread arch animation, mobile touch gestures, and keyboard navigation.
 */

(function () {
  'use strict';

  function initYarnCardsSlider(root) {
    if (!root || root.dataset.ycsInit === 'true') return;
    root.dataset.ycsInit = 'true';

    const trackWrapper = root.querySelector('.ycs-track-wrapper');
    const track = root.querySelector('[data-ycs-track]');
    const prevBtn = root.querySelector('[data-ycs-prev]');
    const nextBtn = root.querySelector('[data-ycs-next]');
    const items = Array.from(root.querySelectorAll('[data-ycs-item]'));

    if (!track || items.length === 0) return;

    let currentIndex = 0;

    function getStep() {
      if (items.length < 2) return items[0].offsetWidth;
      return items[1].offsetLeft - items[0].offsetLeft;
    }

    function getVisibleCount() {
      const containerWidth = trackWrapper ? trackWrapper.clientWidth : root.clientWidth;
      const itemWidth = items[0].offsetWidth;
      if (itemWidth <= 0) return 4;
      return Math.max(1, Math.floor(containerWidth / itemWidth));
    }

    function getMaxIndex() {
      const containerWidth = trackWrapper ? trackWrapper.clientWidth : root.clientWidth;
      const totalWidth = items[items.length - 1].offsetLeft + items[items.length - 1].offsetWidth;
      const maxScroll = totalWidth - containerWidth;
      const step = getStep();
      if (maxScroll <= 4 || step <= 0) return 0;
      return Math.max(0, Math.ceil(maxScroll / step));
    }

    function updateSlidePosition(index, smooth = true) {
      const maxIndex = getMaxIndex();
      if (index < 0) index = 0;
      if (index > maxIndex) index = maxIndex;
      currentIndex = index;

      const step = getStep();
      const containerWidth = trackWrapper ? trackWrapper.clientWidth : root.clientWidth;
      const totalWidth = items[items.length - 1].offsetLeft + items[items.length - 1].offsetWidth;
      const maxScroll = Math.max(0, totalWidth - containerWidth);

      const targetX = Math.min(currentIndex * step, maxScroll);

      track.style.transition = smooth ? 'transform 0.45s cubic-bezier(0.25, 1, 0.5, 1)' : 'none';
      track.style.transform = `translateX(-${targetX}px)`;

      // Update arrow states
      if (prevBtn) {
        prevBtn.disabled = currentIndex <= 0;
      }
      if (nextBtn) {
        nextBtn.disabled = currentIndex >= maxIndex;
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (currentIndex > 0) {
          updateSlidePosition(currentIndex - 1);
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        const maxIndex = getMaxIndex();
        if (currentIndex < maxIndex) {
          updateSlidePosition(currentIndex + 1);
        }
      });
    }

    // Touch Swipe Support for Mobile & Desktop Drag
    let startX = 0;
    let currentX = 0;
    let isTouching = false;

    track.addEventListener('touchstart', function (e) {
      if (e.touches.length === 1) {
        startX = e.touches[0].clientX;
        currentX = startX;
        isTouching = true;
      }
    }, { passive: true });

    track.addEventListener('touchmove', function (e) {
      if (!isTouching) return;
      currentX = e.touches[0].clientX;
    }, { passive: true });

    track.addEventListener('touchend', function () {
      if (!isTouching) return;
      isTouching = false;
      const diffX = startX - currentX;
      const threshold = 40; // minimum swipe distance in px

      if (Math.abs(diffX) > threshold) {
        const maxIndex = getMaxIndex();
        if (diffX > 0 && currentIndex < maxIndex) {
          updateSlidePosition(currentIndex + 1);
        } else if (diffX < 0 && currentIndex > 0) {
          updateSlidePosition(currentIndex - 1);
        }
      }
    });

    // Keyboard navigation
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft' && currentIndex > 0) {
        updateSlidePosition(currentIndex - 1);
      } else if (e.key === 'ArrowRight' && currentIndex < getMaxIndex()) {
        updateSlidePosition(currentIndex + 1);
      }
    });

    // Handle screen resize
    window.addEventListener('resize', function () {
      updateSlidePosition(currentIndex, false);
    }, { passive: true });

    // Initial position
    setTimeout(function () {
      updateSlidePosition(0, false);
    }, 50);
  }

  function initAll() {
    document.querySelectorAll('[data-ycs-root]').forEach(initYarnCardsSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify Customizer Support
  document.addEventListener('shopify:section:load', function (event) {
    const root = event.target.querySelector('[data-ycs-root]') || (event.target.matches('[data-ycs-root]') ? event.target : null);
    if (root) initYarnCardsSlider(root);
  });
})();
